import { FC } from "react";
import { COLORS } from "shared/consts";

type NotificationInviteIconProps = {
  fill?: string;
}
export const NotificationInviteIcon: FC<NotificationInviteIconProps> = ({
  fill = COLORS.NEUTRAL.DEFAULT
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.2797 3C9.20703 3 8.23228 3.62368 7.78278 4.59759L7.13552 6H4C2.89543 6 2 6.89543 2 8V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V8C22 6.89543 21.1046 6 20 6H16.8645L16.2172 4.59759C15.7677 3.62367 14.793 3 13.7203 3H10.2797ZM15.2124 6L14.8553 5.22618C14.651 4.78349 14.2079 4.5 13.7203 4.5H10.2797C9.79211 4.5 9.34904 4.78349 9.14472 5.22618L8.78757 6H15.2124ZM4 7.5H20C20.2761 7.5 20.5 7.72386 20.5 8V10.3508C15.4874 11.5498 8.5126 11.5498 3.5 10.3508V8C3.5 7.72386 3.72386 7.5 4 7.5ZM12.75 12.744C15.4738 12.6999 18.1673 12.4154 20.5 11.8906V18C20.5 18.8284 19.8284 19.5 19 19.5H5C4.17157 19.5 3.5 18.8284 3.5 18V11.8906C5.83272 12.4154 8.52621 12.6999 11.25 12.744V15H12.75V12.744Z" fill={fill}/>
    </svg>
  )
}